"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCsv = exports.ParseError = void 0;
const locale_1 = require("utils/locale");
const papaparse_1 = require("papaparse");
const dayjs_1 = require("utils/dayjs");
class ParseError extends Error {
    constructor(message) {
        super(message);
        this.name = "ParseError";
    }
}
exports.ParseError = ParseError;
function parseExcelDate(dateString, mode) {
    const formats = (() => {
        if (mode === "date")
            return [/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/];
        if (mode === "month")
            return [/(\d{4})[-/](\d{1,2})/];
        if (mode === "datetime")
            return [
                /(\d{4})[-/](\d{1,2})[-/](\d{1,2}) +(\d{1,2}):(\d{2}):(\d{2})/,
                /(\d{4})[-/](\d{1,2})[-/](\d{1,2}) +(\d{1,2}):(\d{2})/,
                /(\d{4})[-/](\d{1,2})[-/](\d{1,2})/,
                /(\d{4})[-/](\d{1,2})/,
            ];
        return [];
    })();
    for (const format of formats) {
        const match = dateString.match(format);
        if (match) {
            const year = parseInt(match[1], 10);
            const month = parseInt(match[2], 10) - 1;
            const day = parseInt(match[3], 10) || 1;
            const hour = parseInt(match[4], 10) || 0;
            const minute = parseInt(match[5], 10) || 0;
            const second = parseInt(match[6], 10) || 0;
            const date = dayjs_1.dayjs.tz({ year, month, day, hour, minute, second }, "Asia/Tokyo");
            return date.valueOf() || null;
        }
    }
    return null;
}
const isNumberLike = (value) => {
    return ((typeof value === "string" && /^-?\d+(\.\d+)?$/.test(value)) ||
        typeof value === "number");
};
const parseCsv = (text, schema) => {
    const parsedCsv = (0, papaparse_1.parse)(text, {
        header: true,
        delimiter: ",",
        quoteChar: '"',
        skipEmptyLines: "greedy",
    });
    const lines = parsedCsv.data;
    const header = parsedCsv.meta.fields;
    if (!header)
        throw new Error();
    const persed = lines.map((line) => {
        let obj = {};
        const arrayLine = Object.values(line);
        arrayLine.forEach((item, index) => {
            var _a, _b;
            const key = header[index];
            const keyComponents = header[index].split(".");
            // eslint-disable-next-line no-constant-condition
            if (true) {
                const property = (_a = schema === null || schema === void 0 ? void 0 : schema.properties) === null || _a === void 0 ? void 0 : _a.find((property) => property.propertyName === keyComponents[0]);
                if (!property)
                    return;
                if (property.schema.schemaType === "datetime" ||
                    property.schema.schemaType === "date" ||
                    property.schema.schemaType === "month") {
                    if (!item) {
                        obj = Object.assign(Object.assign({}, obj), { [key]: null });
                    }
                    else if (typeof item === "string") {
                        const value = parseExcelDate(item, property.schema.schemaType);
                        if (value !== null) {
                            obj = Object.assign(Object.assign({}, obj), { [key]: value });
                        }
                        else {
                            throw new ParseError("日付のフォーマットが不正です");
                        }
                    }
                    else {
                        throw new ParseError("日付のフォーマットが不正です");
                    }
                }
                else if (property.schema.schemaType === "boolean") {
                    const str = `${item}`;
                    if (!item) {
                        obj = Object.assign(Object.assign({}, obj), { [key]: null });
                    }
                    else if (str.toLowerCase() === "false" || str === "0") {
                        obj = Object.assign(Object.assign({}, obj), { [key]: false });
                    }
                    else if (str.toLowerCase() === "true" || str === "1") {
                        obj = Object.assign(Object.assign({}, obj), { [key]: true });
                    }
                    else {
                        throw new ParseError("論理値のフォーマットが不正です");
                    }
                }
                else if (property.schema.schemaType === "selector") {
                    if (!item) {
                        obj = Object.assign(Object.assign({}, obj), { [key]: null });
                    }
                    else {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const option = property.schema.options.find(
                        // 数値と文字列を区別しないで比較する
                        // eslint-disable-next-line eqeqeq, @typescript-eslint/no-explicit-any
                        (option) => option.value == item);
                        if (option) {
                            obj = Object.assign(Object.assign({}, obj), { [key]: item });
                        }
                        else {
                            throw new ParseError("選択肢のフォーマットが不正です");
                        }
                    }
                }
                else if (property.schema.schemaType === "text" ||
                    property.schema.schemaType === "multilineText" ||
                    property.schema.schemaType === "externalKey" ||
                    property.schema.schemaType === "image") {
                    obj = Object.assign(Object.assign({}, obj), { [key]: item || null });
                }
                else if (property.schema.schemaType === "number") {
                    if (isNumberLike(item)) {
                        const value = Number(item);
                        obj = Object.assign(Object.assign({}, obj), { [key]: value });
                    }
                    else {
                        throw new ParseError("数値のフォーマットが不正です");
                    }
                }
                else if (property.schema.schemaType === "textIntl" ||
                    property.schema.schemaType === "multilineTextIntl") {
                    const locale = keyComponents[1] || "ja";
                    const key = keyComponents[0];
                    const oldValue = obj[key];
                    if (oldValue || item) {
                        const newValue = (0, locale_1.getMultiLocaleValues)(Object.assign(Object.assign({}, (typeof oldValue === "string" ? { ja: oldValue } : oldValue)), { [locale]: item }));
                        obj = Object.assign(Object.assign({}, obj), { [key]: newValue });
                    }
                    else {
                        obj = Object.assign(Object.assign({}, obj), { [key]: null });
                    }
                }
                else if (property.schema.schemaType === "array") {
                    if (!item)
                        return;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const subSchema = property.schema.item;
                    const keyValue = keyComponents[0];
                    const arrayIndex = keyComponents[1] - 1; // 1originなので-1する
                    const subKeyValue = keyComponents[2];
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const subSchemaProperty = (_b = subSchema.properties) === null || _b === void 0 ? void 0 : _b.find(
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (property) => property.propertyName === subKeyValue);
                    const oldValue = (obj[keyComponents[0]] ||
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        []);
                    if (Array.isArray(oldValue) && oldValue[arrayIndex]) {
                        const newValue = oldValue.map((oldItem, oldIndex) => {
                            if (oldIndex === arrayIndex) {
                                return Object.assign(Object.assign({}, oldItem), { [subKeyValue]: (subSchemaProperty === null || subSchemaProperty === void 0 ? void 0 : subSchemaProperty.schema.schemaType) === "number" ||
                                        (subSchemaProperty === null || subSchemaProperty === void 0 ? void 0 : subSchemaProperty.schema.schemaType) === "float"
                                        ? Number(item)
                                        : item });
                            }
                            return oldItem;
                        });
                        obj = Object.assign(Object.assign({}, obj), { [keyValue]: newValue });
                    }
                    else {
                        obj = Object.assign(Object.assign({}, obj), { [keyValue]: [
                                ...oldValue,
                                {
                                    [subKeyValue]: (subSchemaProperty === null || subSchemaProperty === void 0 ? void 0 : subSchemaProperty.schema.schemaType) === "number" ||
                                        (subSchemaProperty === null || subSchemaProperty === void 0 ? void 0 : subSchemaProperty.schema.schemaType) === "float"
                                        ? Number(item)
                                        : item,
                                },
                            ] });
                    }
                }
            }
        });
        return Object.keys(obj).length !== 0 ? obj : undefined;
    });
    return persed.filter((item) => item);
};
exports.parseCsv = parseCsv;
